module.exports = __webpack_public_path__ + "img/img19.82230842.svg";